import React, { useState, useEffect } from 'react';
import s from '../../pages/PDV.module.css';
import { getMargemImpressaoMM, setMargemImpressaoMM } from '../../utils/impressaoMargem';

const fmtBRL = v => Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ModalFiscal({ emitirContingencia, modalFiscal, vendaSalva, emitindoFiscal, resultadoFiscal, dadosDiagnostico, setModalDiagnostico, gerarDanfeNfce, gerarDanfeNfe, gerarPreviewDanfeNfce, gerarPreviewDanfeNfe, fecharFiscalELimpar, larguraCupom, setLarguraCupom, finalizarVenda, imprimirBoleto, itensServicoVenda, emitirNfseItem, nfseEmitindo, nfseResultados, clientePJ }) {
  // Margem de segurança da térmica — por computador (localStorage), não por
  // organização: a impressora é física, ligada nesta máquina, e cada modelo
  // tem uma área imprimível real diferente mesmo declarando o mesmo papel.
  const [margemMM, setMargemMM] = useState(() => getMargemImpressaoMM());
  // Este componente nunca desmonta de verdade (o "if (!modalFiscal) return
  // null" abaixo só pula o render, o Fiber continua vivo) — sem isso, o
  // useState acima só lê o localStorage na primeiríssima vez que o modal
  // aparece na sessão. Ajustar a margem por fora (Ctrl+F12 → "📏 Margem
  // Impressão Térmica") não refletia mais aqui — achado real, 2026-09-18,
  // vieiracoffee. Mesma causa raiz do bug já corrigido em
  // ModalMesasComandas.jsx.
  useEffect(() => {
    if (modalFiscal) setMargemMM(getMargemImpressaoMM());
  }, [modalFiscal]);
  const aplicarMargem = (v) => setMargemMM(setMargemImpressaoMM(v));
  if (!modalFiscal) return null;
  return (
        <div className={s.modalOverlay}>
          <div className={s.modalFiscal}>
            <div className={s.modalTitleBar}>
              <span>Venda #{vendaSalva?.id} salva — Documento Fiscal</span>
            </div>
            <div className={s.fiscalBody}>

              {/* Boletos gerados na venda (forma de pagamento Boleto) */}
              {vendaSalva?.boletos?.length > 0 && (
                <div style={{ background: '#eff6ff', border: '1px solid #3b82f6', borderRadius: 6,
                  padding: '8px 12px', marginBottom: 10, fontSize: 12, color: '#1e40af',
                  display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <span>🏦 {vendaSalva.boletos.length} boleto(s) gerado(s) nesta venda</span>
                  {vendaSalva.boletos.map(b => (
                    <button key={b.id}
                      style={{ padding: '3px 10px', fontSize: 12, cursor: 'pointer',
                        border: '1px solid #3b82f6', borderRadius: 4, background: '#fff', color: '#1e40af' }}
                      onClick={() => imprimirBoleto && imprimirBoleto(b)}>
                      🖨️ Boleto #{b.id}
                    </button>
                  ))}
                </div>
              )}
              {vendaSalva?.aviso_boleto && (
                <div style={{ background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: 6,
                  padding: '8px 12px', marginBottom: 10, fontSize: 12, color: '#92400e' }}>
                  ⚠ {vendaSalva.aviso_boleto}
                </div>
              )}

              {/* Serviços desta venda — NFS-e (uma DPS por item; ainda não transmite de verdade) */}
              {itensServicoVenda?.length > 0 && (
                <div style={{ background: '#f5f3ff', border: '1px solid #a78bfa', borderRadius: 6,
                  padding: '8px 12px', marginBottom: 10, fontSize: 12, color: '#4c1d95' }}>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>🧾 Serviços desta venda (NFS-e)</div>
                  {itensServicoVenda.map(item => {
                    const resultado = nfseResultados?.[item.id];
                    return (
                      <div key={item.id} style={{ marginBottom: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                          <span>{item.descricao} — R$ {fmtBRL(item.subtotal)}</span>
                          <button style={{ padding: '3px 10px', fontSize: 12, cursor: 'pointer',
                            border: '1px solid #7c3aed', borderRadius: 4, background: '#fff', color: '#7c3aed' }}
                            disabled={nfseEmitindo === item.id}
                            onClick={() => emitirNfseItem(item)}>
                            {nfseEmitindo === item.id ? 'Gerando…' : '🧾 Gerar DANFE'}
                          </button>
                        </div>
                        {resultado && (resultado.erro || resultado.motivo) && (
                          <div style={{ marginTop: 4, fontSize: 11, color: resultado.sucesso ? '#57534e' : '#b91c1c' }}>
                            {resultado.erro || resultado.motivo}
                            {resultado.status ? ` (status ${resultado.status})` : ''}
                          </div>
                        )}
                        {resultado?.sucesso && (
                          <div style={{ marginTop: 4, fontSize: 11, color: '#15803d' }}>
                            ✔ NFS-e nº {resultado.numero_nfse} emitida com sucesso.
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Aguardando emissão */}
              {emitindoFiscal && (
                <div className={s.fiscalEmitindo}>
                  <p>Transmitindo para SEFAZ...</p>
                </div>
              )}

              {/* Resultado da emissão */}
              {!emitindoFiscal && resultadoFiscal && (
                <div className={resultadoFiscal.sucesso ? s.fiscalAutorizado : s.fiscalRejeitado}>
                  <p className={s.fiscalResultTitulo}>
                    {resultadoFiscal.contingencia ? '✔ Emitida em contingência'
                      : resultadoFiscal.sucesso ? '✔ Autorizado' : '✘ Rejeitado/Erro'}
                  </p>
                  <p>{resultadoFiscal.motivo}</p>
                  {resultadoFiscal.chave_acesso && (
                    <p style={{ fontSize: 10, wordBreak: 'break-all', marginTop: 4 }}>
                      Chave: {resultadoFiscal.chave_acesso}
                    </p>
                  )}
                  {resultadoFiscal.protocolo && (
                    <p>Protocolo: {resultadoFiscal.protocolo}</p>
                  )}
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 10, flexWrap: 'wrap' }}>
                    {!resultadoFiscal.sucesso && resultadoFiscal.pode_contingencia && (
                      <button className={s.fiscalBtnImprimir} onClick={emitirContingencia}
                        title="O cupom sai agora e o sistema transmite assim que a SEFAZ responder">
                        📄 Emitir em contingência
                      </button>
                    )}
                    {!resultadoFiscal.sucesso && dadosDiagnostico && (
                      <button className={s.fiscalBtnDiag} onClick={() => setModalDiagnostico(true)}>
                        🔍 Ver diagnóstico
                      </button>
                    )}
                    {resultadoFiscal.sucesso && resultadoFiscal.tipo === 'nfce' && (
                      <button className={s.fiscalBtnImprimir}
                        onClick={() => gerarDanfeNfce(resultadoFiscal, larguraCupom)}>
                        Reimprimir DANFE
                      </button>
                    )}
                    {resultadoFiscal.sucesso && resultadoFiscal.tipo === 'nfe' && (
                      <button className={s.fiscalBtnImprimir}
                        onClick={() => gerarDanfeNfe(resultadoFiscal)}>
                        Reimprimir DANFE
                      </button>
                    )}
                    {!resultadoFiscal.sucesso && resultadoFiscal.tipo === 'nfce' && (
                      <button className={s.fiscalBtnPrevia}
                        onClick={() => gerarPreviewDanfeNfce(larguraCupom)}>
                        Prévia NFC-e (sem valor fiscal)
                      </button>
                    )}
                    {!resultadoFiscal.sucesso && resultadoFiscal.tipo === 'nfe' && (
                      <button className={s.fiscalBtnPrevia}
                        onClick={gerarPreviewDanfeNfe}>
                        Prévia NF-e (sem valor fiscal)
                      </button>
                    )}
                    <button className={s.fiscalBtnSem} onClick={fecharFiscalELimpar}>
                      {resultadoFiscal.sucesso ? 'Concluir' : 'Fechar'}
                    </button>
                  </div>
                </div>
              )}

              {/* Tela inicial — escolha de documento */}
              {!emitindoFiscal && !resultadoFiscal && (<>
                <div className={s.fiscalIcone}>🧾</div>
                <p className={s.fiscalPergunta}>Deseja emitir documento fiscal?</p>

                <div className={s.fiscalLargura}>
                  <span className={s.fiscalLarguraLabel}>Largura do cupom:</span>
                  {['58mm','80mm'].map(l => (
                    <label key={l} className={s.fiscalLarguraOpt}>
                      <input type="radio" name="largura" value={l}
                        checked={larguraCupom === l}
                        onChange={() => setLarguraCupom(l)} />
                      {l}
                    </label>
                  ))}
                  <label className={s.fiscalLarguraOpt}
                    title="Se a impressora térmica desta máquina corta as laterais do cupom, aumente essa margem — desconta dos dois lados da largura acima. Fica salvo só neste computador.">
                    Margem impressora (mm):
                    <input type="number" min="0" max="20" step="0.5" value={margemMM}
                      onChange={e => aplicarMargem(e.target.value)}
                      style={{ width: 48, marginLeft: 4 }} />
                  </label>
                </div>

                {clientePJ && (
                  <p style={{ fontSize: 11.5, color: '#92400e', background: '#fffbeb',
                    border: '1px solid #f59e0b', borderRadius: 6, padding: '4px 10px', marginBottom: 8 }}>
                    Cliente pessoa jurídica — disponível apenas NF-e (e NFS-e para itens de serviço).
                  </p>
                )}
                <div className={s.fiscalBotoes}>
                  {!clientePJ && (
                    <button className={s.fiscalBtnNfce} onClick={() => finalizarVenda('nfce')}>
                      <span className={s.fiscalTecla}>1</span>
                      <strong>NFC-e</strong><span>Nota Fiscal ao Consumidor</span>
                    </button>
                  )}
                  <button className={s.fiscalBtnNfe} onClick={() => finalizarVenda('nfe')}>
                    <span className={s.fiscalTecla}>2</span>
                    <strong>NF-e</strong><span>Nota Fiscal Eletrônica</span>
                  </button>
                  <button className={s.fiscalBtnImprimir} onClick={() => finalizarVenda('imprimir')}>
                    <span className={s.fiscalTecla}>3</span>
                    <strong>Salvar e Imprimir</strong><span>Cupom não fiscal ({larguraCupom})</span>
                  </button>
                  <button className={s.fiscalBtnSem} onClick={() => finalizarVenda('sem')}>
                    <span className={s.fiscalTecla}>4</span>
                    <strong>Salvar sem imprimir</strong><span>Apenas registrar</span>
                  </button>
                  <button className={s.fiscalBtnA4} onClick={() => finalizarVenda('a4')}>
                    <span className={s.fiscalTecla}>5</span>
                    <strong>Salvar e Imprimir A4</strong><span>Pedido em formato A4</span>
                  </button>
                </div>

                <div className={s.fiscalPrevia}>
                  <span className={s.fiscalPreviaSep}>Conferência visual — sem transmissão</span>
                  <div className={s.fiscalPreviaBtns}>
                    {!clientePJ && (
                      <button className={s.fiscalBtnPrevia} onClick={() => gerarPreviewDanfeNfce(larguraCupom)}>
                        Prévia NFC-e ({larguraCupom})
                      </button>
                    )}
                    <button className={s.fiscalBtnPrevia} onClick={gerarPreviewDanfeNfe}>
                      Prévia NF-e (A4)
                    </button>
                  </div>
                </div>
              </>)}

            </div>
          </div>
        </div>
  );
}
